import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { ComponentSync, LL_H_C, LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import './Component_Cockpit_FindingsHighlight.scss';
import { findingViewSectionType_ByOrder } from '@app/advisor-ui-shared';
import { AdvisorConfigKeyFE_FindingView_Cockpit } from '@app/advisor-frontend';
import { FadeScrollWrapper } from '@app/styles';
import { ModuleFE_Advisor_FindingView } from '@app/advisor-frontend';
import { Component_FindingViewSection } from '../../../panels/AdvisorPanel_Findings/components/Component_FindingViewSection/Component_FindingViewSection.js';
import { deepClone } from '@nu-art/ts-common';
export class Component_Cockpit_FindingsHighlight extends ComponentSync {
    //######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        state.cockpitConfig = AdvisorConfigKeyFE_FindingView_Cockpit.get();
        return state;
    }
    render() {
        return _jsxs(LL_V_L, { className: 'cockpit-panel cockpit-finding-highlights', children: [this.render_Header(), this.render_FindingViews()] });
    }
    render_Header = () => {
        return _jsx(LL_H_C, { className: 'cockpit-panel__header', children: "Test Results" });
    };
    render_FindingViews = () => {
        const configs = this.state.cockpitConfig?.testResults;
        if (!configs?.length)
            return;
        return _jsx(FadeScrollWrapper, { children: configs.map(this.render_FindingView) });
    };
    render_FindingView = (config) => {
        //deep clone the FV as we are about to change data on it
        const findingView = deepClone(ModuleFE_Advisor_FindingView.cache.unique(config.findingViewId));
        return _jsx(React.Fragment, { children: findingView.sections.map((section, index) => {
                section.config.alwaysVisible = false; //No section is always visible here
                return _jsx(Component_FindingViewSection, { section: section, hideIfEmpty: true, hideSectionLabel: section.type === findingViewSectionType_ByOrder, onlyAbnormalResults: config.onlyAbnormalResults }, index);
            }) }, findingView._id);
    };
}
//# sourceMappingURL=Component_Cockpit_FindingsHighlight.js.map